import Logger from '@owc-utils/common/Logger';
import { ConnectionInstance } from './BackportPluginComponent';
import { VALUES } from './BackportPluginComponent.config';

const eventHandlers: Map<string, Map<string, Function>> = new Map();

export default class Lifecycle {
  private channelId: string;
  private connection: ConnectionInstance;
  private pluginId: string;
  private instanceEventHandlers: Map<string, Function>;

  constructor(connection: ConnectionInstance, pluginInstanceId: string) {
    this.connection = connection;
    this.pluginId = pluginInstanceId;
    this.channelId = `${pluginInstanceId.toUpperCase()}-${VALUES.channelSuffix}`;
    this.instanceEventHandlers = new Map();
    eventHandlers.set(this.channelId, this.instanceEventHandlers);
    this.subscribeToChannelMessages();
  }

  private subscribeToChannelMessages() {
    this.connection.subscribe(this.channelId, (messageEvent: object) => {
      Logger.debug('[Lifecycle] channel message received', this.channelId, messageEvent);
      const message = JSON.parse((messageEvent as any).message);
      const messageType = message.messageType;
      if (typeof messageType !== 'string') {
        return;
      }

      const handler = this.instanceEventHandlers.get(messageType);
      if (handler == null) {
        return;
      }

      Logger.debug('[Lifecycle] message is gonna be handled now');
      handler(message.data);
    });
  }

  private cleanUp(type: string, hasReceivedResponse: boolean, callback?: Function) {
    this.unsubscribe(type);
    if (callback != null) {
      callback(hasReceivedResponse);
    }
  }

  public getPluginInstanceId(): string {
    return this.pluginId;
  }

  public subscribe(messageType: string, messageHandler: Function): void {
    if (this.instanceEventHandlers.has(messageType)) {
      throw new Error(
        `[LifeCycleManager] trying to re-subscribe to an already subscribed message type ${messageType}.`,
      );
    }
    this.instanceEventHandlers.set(messageType, messageHandler);
  }

  public unsubscribe(messageType: string) {
    this.instanceEventHandlers.delete(messageType);
  }

  public publishLifecycleMessage(messageType: string, payload: object, callback: Function): void {
    // Subscribe to the lifecycle response message.
    const responseMessageType = messageType + 'Response';

    const timeoutId = window.setTimeout(() => {
      this.cleanUp(responseMessageType, false, callback);
    }, VALUES.responseTimeOutMs);
    this.subscribe(responseMessageType, () => {
      window.clearTimeout(timeoutId);
      this.cleanUp(responseMessageType, true, callback);
    });

    this.publish(messageType, payload);
  }

  public publish(messageType: string, payload: object): void {
    const message = {
      messageType: messageType,
      data: payload,
    };
    this.connection.publish(this.channelId, JSON.stringify(message));
  }
}
